import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import layoutExample4 from './assets/images/layout-example4.png';


const CSSLesson21 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
   div  .ex1 {
    width: 500px;
    margin: auto;
    border: 3px solid #cc5500;
   }

   div  ex2 {
    max-width: 500px;
    margin: auto;
    border: 3px solid #cc5500
   }

  `
  );
  


  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>
          
          <div className="alert alert-secondary" role="alert">
          <h3>width and max-width</h3>
    <p>As mentioned in the previous lesson, a block-level element always takes up the full width available (stretches out to the left and right as far as it can).</p>
    <p>Setting the width of a block-level element will prevent it from stretching out to the edges of its container. Then, you can set the margins to auto, to horizontally center the element within its container.</p> 
    <p>The element will take up the specified width, and the remaining space will be split equally between the two margins.</p>

    <CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p>The problem with the <b class="text-danger">&lt;div&gt;</b> above occurs when the browser window is smaller than the width of the element. The browser then adds a horizontal scrollbar to the page.</p>
<p>Using max-width instead, in this situation, will improve the browser's handling of small windows. This is important when making a site usable on small devices.</p>
<p>The max-width CSS property sets the maximum width of an element and prevents the used value of the width property from becoming larger than the value specified by max-width.</p>
<p>When using max-width, you have to ensure that elements set with a max-width are not truncated and/or do not obscure other content when the page is zoomed to increase text size.</p>
  </div>
                </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson21;
